import { type ReactNode } from 'react';

interface ItemCardProps {
  title: string;
  subtitle?: string;
  badge?: ReactNode;
  meta?: string;
  onClick?: () => void;
  children?: ReactNode;
}

export function ItemCard({ title, subtitle, badge, meta, onClick, children }: ItemCardProps) {
  return (
    <div
      onClick={onClick}
      className={`bg-white border border-gray-200 rounded-xl p-4 transition-shadow ${
        onClick ? 'cursor-pointer hover:shadow-md hover:border-brand-200' : ''
      }`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          <h3 className="font-medium text-gray-900 truncate">{title}</h3>
          {subtitle && (
            <p className="text-sm text-gray-500 mt-0.5 line-clamp-2">{subtitle}</p>
          )}
        </div>
        {badge && <div className="shrink-0">{badge}</div>}
      </div>
      {meta && <p className="text-xs text-gray-400 mt-2">{meta}</p>}
      {children && <div className="mt-3">{children}</div>}
    </div>
  );
}
